// import React, { useEffect, useState } from 'react';
// import Navigation from './components/Navigation';
// import Sidebar from './components/Sidebar';
// import { BsFillArchiveFill, BsFillGrid3X3GapFill, BsPeopleFill } from 'react-icons/bs';
// import { NavLink } from 'react-router-dom';
// import base_url from './config/Config';

// const Dashboard = () => {
//   const [fintechCount, setFintechCount] = useState(0);

//   useEffect(() => {
//     const fetchFintechCount = async () => {
//       try {
//         const response = await fetch(`${base_url}/api1/user/countFintechPartner`, {
//           method: 'GET',
//           headers: { 'Content-Type': 'application/json' },
//         });

//         if (response.ok) {
//           const data = await response.json();
//           console.log('Fetched fintech count:', data.count);
//           setFintechCount(data.count); // Assuming the response contains { count: number }
//         } else {
//           console.error('Failed to fetch fintech count');
//         }
//       } catch (error) {
//         console.error('Error fetching fintech count:', error);
//       }
//     };

//     fetchFintechCount();
//   }, []);

//   return (
//     <>  
//       <div className='overviewsaa'>
//         <h4>Dashboard</h4>
//       </div>
//       <div className='navigationss'>
//         <Navigation />
//       </div>
//       <div className='container-fluid'>
//         <div className='row'>
//           <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//             <div className='lmssidebar'>
//               <Sidebar/>
//             </div>
//           </div>
//           <div className='col-lg-10 col-md-10 mt-5'>
//             <div className='dashboardlms mt-5 text-center'>
//               <div className='row'>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/fintech/Fintech">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillGrid3X3GapFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Fintech Partner</span><br />
//                           <span className='noofenquery'>{fintechCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/Customer">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsPeopleFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Total Borrower</span><br />
//                           <span className='noofenquery'>38435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/Customer">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillArchiveFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Active Borrower</span><br />
//                           <span className='noofenquery'>38435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/Customer">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillArchiveFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Close Borrower</span><br />
//                           <span className='noofenquery'>435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillGrid3X3GapFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Outstanding</span><br />
//                           <span className='noofenquery'>38435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillGrid3X3GapFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>TOB</span><br />
//                           <span className='noofenquery'>38435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 mt-3'>
//                   <NavLink to="/">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillGrid3X3GapFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Collected v/s Demand</span> <br />
//                           <span className='noofenquery'>38435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 {/* <div className='col-md-3 mt-3'>
//                   <NavLink to="/">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4'>
//                           <span className='iconl'><BsFillGrid3X3GapFill /></span>
//                         </div>
//                         <div className='col-md-9 mt-3 boxcontent'>
//                           <span>Profit/Loss</span> <br />
//                           <span className='noofenquery'>38435</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div> */}
//                 <div className='col-md-3 mt-3'>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard;



// import React, { useEffect, useState } from 'react';
// import Navigation from './components/Navigation';
// import Sidebar from './components/Sidebar';
// import { BsPersonCircle, BsFillGrid3X3GapFill, BsPeopleFill, BsHouseCheckFill,BsFillXOctagonFill,BsXCircleFill,BsXOctagonFill,BsPatchCheckFill } from 'react-icons/bs';
// import { NavLink } from 'react-router-dom';
// import base_url from './config/Config';

// const Dashboard = () => {
//   const [borrowerCount, setBorrowerCount] = useState(0);
//   const [readyToDisburseCount, setReadyToDisburseCount] = useState(0);
//   const [disburseCount, setDisburseCount] = useState(0);
//   const [rejectCount, setRejectCount] = useState(0);
//   const [creditCount, setCreditCount] = useState(0);
//   const [pennyCount, setPennyCount] = useState(0);
//   const [loanCount, setLoanCount] = useState(0);
//   const [newCount, setNewCount] = useState(0);

//   // Reusable function to fetch counts
//   const fetchCount = async (endpoint, setCountFunction) => {
//     try {
//       const response = await fetch(`${base_url}${endpoint}`, {
//         method: 'GET',
//         headers: { 'Content-Type': 'application/json' },
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setCountFunction(data.count || data);  // Adjust if your API structure differs
//       } else {
//         console.error(`Failed to fetch data from ${endpoint}:`, response.statusText);
//       }
//     } catch (error) {
//       console.error(`Error fetching data from ${endpoint}:`, error.message);
//     }
//   };

//   useEffect(() => {
//     fetchCount('/api1/customer/count', setBorrowerCount);
//     fetchCount('/api1/customer/customersReadyToDisburseCount', setReadyToDisburseCount);
//     fetchCount('/api1/customer/customersDisbursedCount', setDisburseCount);
//     fetchCount('/api1/customer/rejectCount', setRejectCount);
//     fetchCount('/api1/customer/rejectCustomersCreditCount', setCreditCount);
//     fetchCount('/api1/customer/rejectCustomersPennyCount', setPennyCount);
//     fetchCount('/api1/customer/loanCount', setLoanCount);
//     fetchCount('/api1/customer/newCount', setNewCount);
//   }, []);  // Runs once when the component mounts

//   return (
//     <>
//       <div className='overviewsaa'>
//         <h4>Dashboard</h4>
//       </div>
//       <div className='navigationss'>
//         <Navigation />
//       </div>
//       <div className='container-fluid'>
//         <div className='row'>
//           <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//             <div className='lmssidebar'>
//               <Sidebar />
//             </div>
//           </div>
//           <div className='col-lg-10 col-md-10 mt-5'>
//             <div className='dashboardlms mt-5 text-center'>
//               <div className='row'>
//                 {/* Card 1 */}
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/Operation/Employee">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 mt-4 col-4'>
//                           <span className='iconl'><BsPersonCircle /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>New Borrower</span><br />
//                           <span className='noofenquery'>{newCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/Operation/AllCustomer">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsFillGrid3X3GapFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Total Borrower</span><br />
//                           <span className='noofenquery'>{borrowerCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>

//                 {/* Card 2 */}
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/account/PendingDisbursement">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsPeopleFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Disbursed Pending</span><br />
//                           <span className='noofenquery'>{readyToDisburseCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>

//                 {/* Card 3 */}
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/account/disbursement">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsPatchCheckFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Total Disbursed</span><br />
//                           <span className='noofenquery'>{disburseCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/Loanmaster/Product">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsHouseCheckFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Total Loan</span><br />
//                           <span className='noofenquery'>{loanCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/operation/Reject">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsFillXOctagonFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Total Reject</span><br />
//                           <span className='noofenquery'>{rejectCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 col-sm-12 mt-3'>
//                   <NavLink to="/Operation/CreditCheck">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsXCircleFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Credit Reject</span><br />
//                           <span className='noofenquery'>{creditCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>
//                 <div className='col-md-3 col-sm-12 mt-3 mb-5'>
//                   <NavLink to="/Operation/BankVerification">
//                     <div className='iq-card-body'>
//                       <div className='row'>
//                         <div className='col-md-3 col-4 mt-4'>
//                           <span className='iconl'><BsXOctagonFill /></span>
//                         </div>
//                         <div className='col-md-9 col-8 mt-3 boxcontent'>
//                           <span>Bank Reject</span><br />
//                           <span className='noofenquery'>{pennyCount}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </NavLink>
//                 </div>

//                 {/* Additional cards can follow this pattern */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard;



import React, { useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import { BsPersonCircle, BsFillGrid3X3GapFill, BsFillXOctagonFill, BsPatchCheckFill, BsCurrencyRupee, BsClockHistory, BsXCircleFill } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import base_url from './config/Config';
import PageLoader from './components/PageLoader';

const StatCard = ({ to, icon, label, value, colorClass }) => (
  <div className='col-xl-3 col-md-4 col-sm-6 mb-4'>
    <NavLink to={to} className="stat-card-link">
      <div className={`stat-card ${colorClass}`}>
        <div className="stat-icon-wrap">
          {icon}
        </div>
        <div className="stat-info">
          <p className="stat-label">{label}</p>
          <h3 className="stat-value">{value}</h3>
        </div>
      </div>
    </NavLink>
  </div>
);

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalPending: 0,
    totalActive: 0,
    totalToday: 0,
    totalRejected: 0,
    totalLoanReject: 0,
    totalLoanPending: 0,
    totalLoanActive: 0
  });
  const [pageLoading, setPageLoading] = useState(true);

  // Fetch all stats in one call
  const fetchStats = async () => {
    try {
      const response = await fetch(`${base_url}/api/customerFilter/stats`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        const data = await response.json();
        setStats(data);
      } else {
        console.error("Failed to fetch stats:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching stats:", error.message);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  if (pageLoading) return <PageLoader text="Loading Dashboard..." />;

  return (
    <>
      <div className='overviewsaa'>
        <h4>Dashboard</h4>
      </div>
      <div className='navigationss'>
        <Navigation />
      </div>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-lg-2 col-md-2 sidebarnavigartion'>
            <div className='lmssidebar'>
              <Sidebar />
            </div>
          </div>
          <div className='col-lg-10 col-md-10 mt-5'>
            <div className='dashboard-content mt-5'>
              <div className='dashboard-section-title'>Customer Overview</div>
              <div className='row'>
                <StatCard to="/operation/pending" icon={<BsClockHistory />} label="Total Pending" value={stats.totalPending} colorClass="card-orange" />
                <StatCard to="/operation/active" icon={<BsFillGrid3X3GapFill />} label="Total Active" value={stats.totalActive} colorClass="card-green" />
                <StatCard to="/operation/today" icon={<BsPatchCheckFill />} label="Today Customers" value={stats.totalToday} colorClass="card-blue" />
                <StatCard to="/operation/rejected" icon={<BsFillXOctagonFill />} label="Total Rejected" value={stats.totalRejected} colorClass="card-red" />
              </div>
              <div className='dashboard-section-title mt-2'>Loan Overview</div>
              <div className='row'>
                <StatCard to="/operation/rejected" icon={<BsCurrencyRupee />} label="Total Loan Active" value={stats.totalLoanActive} colorClass="card-teal" />
                <StatCard to="/operation/rejected" icon={<BsPersonCircle />} label="Total Loan Pending" value={stats.totalLoanPending} colorClass="card-purple" />
                <StatCard to="/operation/rejected" icon={<BsXCircleFill />} label="Total Loan Rejected" value={stats.totalLoanReject} colorClass="card-dark" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;



